export default __webpack_public_path__ + "static/media/body-background.8cfa63db.webp";